import {formattedDate} from '@/utils/formattedDate';
import {MONTH_DAY_FORMAT, MONTH_DAY_YEAR_FORMAT} from '@/config/timeFormats';

export default function formatMessageDate(dateString: string): string {
  const date = new Date(dateString);
  const format =
    date.getFullYear() === new Date().getFullYear()
      ? MONTH_DAY_FORMAT
      : MONTH_DAY_YEAR_FORMAT;
  return formattedDate(date, format);
}
